import { render } from "./UserPanelView.vue?vue&type=template&id=6a85dea4&scoped=true"
import script from "./UserPanelView.vue?vue&type=script&lang=js"
export * from "./UserPanelView.vue?vue&type=script&lang=js"

import "./UserPanelView.vue?vue&type=style&index=0&id=6a85dea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a85dea4"]])

export default __exports__